import { oktaAuth } from '~/config/oktaConfig';
import log from '~/logger';
export const fetchLookups = async () => {
    try {
        const baseUrl = process.env.REACT_APP_PULSE_BFF_API_BASE_URL;
        if (!baseUrl) {
            log.error('REACT_APP_PULSE_BFF_API_BASE_URL is not configured');
            return {};
        }
        const accessToken = oktaAuth.getAccessToken();
        const response = await fetch(`${baseUrl}/product_planning/reference_data/v1`, {
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        });
        if (!response.ok) {
            log.error('Failed to fetch lookups - non-OK response', {
                status: response.status,
                statusText: response.statusText
            });
            return {};
        }
        const data = (await response.json());
        return data ?? {};
    }
    catch (error) {
        log.error('Failed to fetch lookups', error);
        return {};
    }
};
